module.exports = __webpack_public_path__ + "static/media/google-pay.03a2392a.png";